<template>
	<svg :width="width" :height="height" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.41662" fill-rule="evenodd" clip-rule="evenodd" d="M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z" fill="#FEB103"/>
		<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="128" height="128">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z" fill="white"/>
		</mask>
		<g mask="url(#mask0)">
			<rect x="125.989" y="-88.6124" width="8" height="416" transform="rotate(44 125.989 -88.6124)" fill="#FFFDF5"/>
			<rect x="154.502" y="-98.1719" width="8" height="416" transform="rotate(44 154.502 -98.1719)" fill="#FFFDF5"/>
			<rect x="164.502" y="-88.1719" width="8" height="416" transform="rotate(44 164.502 -88.1719)" fill="#FFFDF5"/>
			<rect x="174.502" y="-78.1719" width="8" height="416" transform="rotate(44 174.502 -78.1719)" fill="#FFFDF5"/>
			<rect x="184.502" y="-69.1719" width="8" height="416" transform="rotate(44 184.502 -69.1719)" fill="#FFFDF5"/>
		</g>
	</svg>
</template>

<script>
    export default {
      name: "StripedCircle",
      props: {
        height: {
          type: Number,
          default: 256
        },
        width: {
          type: Number,
          default: 256
        }
      }
    }
</script>

<style scoped>

</style>
